import { Video } from 'lucide-react';

interface VideoPlayerProps {
  url?: string | null;
  className?: string;
}

function extractYouTubeId(url: string): string | null {
  const patterns = [
    /youtu\.be\/([\w-]{11})/,
    /youtube\.com\/watch\?v=([\w-]{11})/,
    /youtube\.com\/embed\/([\w-]{11})/,
    /youtube\.com\/shorts\/([\w-]{11})/,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m) return m[1];
  }
  return null;
}

export default function VideoPlayer({ url, className = '' }: VideoPlayerProps) {
  if (!url) {
    return (
      <div
        className={`aspect-video w-full rounded-lg bg-ngs-surface border border-ngs-cyan/20 flex flex-col items-center justify-center text-gray-400 ${className}`}
      >
        <Video className="h-12 w-12 mb-2 opacity-60" />
        <p className="text-sm">Video pendiente de carga</p>
      </div>
    );
  }

  const ytId = extractYouTubeId(url);
  if (ytId) {
    return (
      <div className={`aspect-video w-full rounded-lg overflow-hidden ${className}`}>
        <iframe
          src={`https://www.youtube.com/embed/${ytId}`}
          title="Video de capacitación"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full border-0"
        />
      </div>
    );
  }

  if (/\.(mp4|webm|mov|m4v)(\?.*)?$/i.test(url)) {
    return (
      <div className={`aspect-video w-full rounded-lg overflow-hidden bg-black ${className}`}>
        <video controls src={url} className="w-full h-full" />
      </div>
    );
  }

  return (
    <div
      className={`aspect-video w-full rounded-lg bg-ngs-surface border border-yellow-500/40 flex items-center justify-center text-yellow-400 ${className}`}
    >
      <p className="text-sm">Formato de video no soportado</p>
    </div>
  );
}
